@if (config()) {
  <div class="parameter-collars-config">
    <mat-form-field
      class="parameter-collars-config__field example-chip-list textarea without-subscript small-form-field"
      appearance="outline"
    >
      @if (!hideLabel()) {
        <mat-label>{{ parameterTitle }}</mat-label>
      }
      <mat-chip-grid #chipList aria-label="Collars">
        @for (collar of selectedCollars$ | async; let i = $index; track collar) {
          @if (showMore || i < 4) {
            <mat-chip-row
              class="example-chip-list__chip"
              (removed)="remove(collar)"
              [disabled]="disabled()"
            >
              {{ collar }}
              @if (showMore) {
                <button matChipRemove>
                  <mat-icon class="example-chip-list__delete" color="warn">cancel</mat-icon>
                </button>
              }
            </mat-chip-row>
          }
        }

        @if (!selectedCollars$.value?.length) {
          @for (collar of factoryCollars$ | async; track collar) {
            @if (showMore) {
              <mat-chip-row class="example-chip-list__chip factory-chip" [disabled]="true">
                {{ collar }} (Factory)
              </mat-chip-row>
            }
          }
        }
        @if (!showMore && (selectedCollars$ | async)?.length > 4) {
          <mat-chip-row class="example-chip-list__chip">
            +{{ (selectedCollars$ | async)?.length - 4 }}
          </mat-chip-row>
        }
        <div class="parameter-collars-config__input-container">
          <input
            class="parameter-collars-config__input"
            #collarInput
            placeholder="Add collar"
            [formControl]="collarCtrl"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="add()"
            (keyup.enter)="selectOption()"
            (blur)="onInputBlur()"
          />
        </div>
      </mat-chip-grid>
    </mat-form-field>
    @if (config().parameter.description && showInfo()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button>
          <mat-icon
            class="parameter-collars-config__icon"
            color="primary"
            [matTooltip]="config().parameter.description"
            >info_outline
          </mat-icon>
        </button>
      </div>
    }
    @if ((userValue() || factoryValue()) && !readonly() && hasDelete() && !disabled()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button>
          <mat-icon
            (click)="onClickRemove()"
            class="parameter-collars-config__close"
            color="warn"
            matTooltip="Discard changes"
            >close
          </mat-icon>
        </button>
      </div>
    }
    @if ((userValue() || factoryValue()) && !readonly() && hasUndo() && !disabled()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button>
          <mat-icon
            (click)="onClickUndo()"
            class="parameter-collars-config__close"
            color="warn"
            matTooltip="Discard changes"
            >close
          </mat-icon>
        </button>
      </div>
    }
    @if (hasClose() && !disabled()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button>
          <mat-icon (click)="onClickClose()" matTooltip="Close">close</mat-icon>
        </button>
      </div>
    }
    @if (showReset() && !disabled()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button (click)="onResetToFactory()" [matTooltip]="resetToFactoryTooltip()">
          <mat-icon color="warn">replay</mat-icon>
        </button>
      </div>
    }
  </div>
}
